import { motion } from 'framer-motion';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LocationListItem from './LocationListItem';


function LocationList({cols, locations, basePath, organizationUniqueName,
                      isPublic, menu, emptyMessage, noLink}) {
  const mdWidth= cols === 'single' ? 12 : 4;
  const smWidth= cols === 'single' ? 12 : 6;

  if (!locations) {
    return null;
  }

  if (locations.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center h-full">
        <Typography color="text.secondary" variant="h6">
          {emptyMessage}
        </Typography>
      </div>
    );
  }


  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
        <Grid container spacing={2} alignItems="stretch" className="w-full m-0 p-0">
          {locations.map((location) => (
			<Grid key={location.id} item xs={12} sm={smWidth} md={mdWidth}>
            	<LocationListItem key={location.id} 
            	                location={location} 
            	                basePath={basePath}
                                  organizationUniqueName={organizationUniqueName}
                                  isPublic={isPublic}
                                  noLink={noLink}
            	                menu={menu}/>
            </Grid>
          ))}
        </Grid>
         
    </motion.div>
  );
}

export default LocationList;
